import React from "react";
import ScrollUpButton from "react-scroll-up-button";
import "./index.css";

const BackToTop = () => (
  <div>
    <ScrollUpButton
      ContainerClassName="AnyClassForContainer"
      TransitionClassName="AnyClassForTransition"
      npm
    />
  </div>
);

export default BackToTop;
